export default __webpack_public_path__ + "static/media/campaigns-upcoming-empty.1a9df23a.svg";